import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
var Status = /*#__PURE__*/function (Status) {
  Status["SUCCESS"] = "success";
  Status["ERROR"] = "error";
  return Status;
}(Status || {});
var _authToken = /*#__PURE__*/_classPrivateFieldLooseKey("authToken");
var _configuration = /*#__PURE__*/_classPrivateFieldLooseKey("configuration");
var _endpointUrl = /*#__PURE__*/_classPrivateFieldLooseKey("endpointUrl");
var _fetch = /*#__PURE__*/_classPrivateFieldLooseKey("fetch");
export default class RECSender {
  constructor(endpointUrl, authToken, configuration, {
    fetch = globalThis.fetch
  } = {}) {
    Object.defineProperty(this, _authToken, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _configuration, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _endpointUrl, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _fetch, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _authToken)[_authToken] = authToken;
    _classPrivateFieldLooseBase(this, _configuration)[_configuration] = configuration;
    _classPrivateFieldLooseBase(this, _endpointUrl)[_endpointUrl] = endpointUrl;
    _classPrivateFieldLooseBase(this, _fetch)[_fetch] = fetch;
  }
  setAuthToken(authToken) {
    _classPrivateFieldLooseBase(this, _authToken)[_authToken] = authToken;
  }
  send(payload, acknowledge, {
    fetch = _classPrivateFieldLooseBase(this, _fetch)[_fetch]
  } = {}) {
    var _this = this;
    return _asyncToGenerator(function* () {
      try {
        const response = yield fetch(`${_classPrivateFieldLooseBase(_this, _endpointUrl)[_endpointUrl]}${_classPrivateFieldLooseBase(_this, _authToken)[_authToken]}`, {
          method: 'POST',
          body: JSON.stringify(payload)
        });
        const json = yield response.json();
        if (json.modifiers) {
          if (json.modifiers.batch_max_events) {
            _classPrivateFieldLooseBase(_this, _configuration)[_configuration].maxBatchSize = json.modifiers.batch_max_events;
          }
          if (json.modifiers.batch_threshold_wait_ms) {
            _classPrivateFieldLooseBase(_this, _configuration)[_configuration].autoSendInterval = json.modifiers.batch_threshold_wait_ms;
          }
        }
        if (json.status === Status.SUCCESS) {
          acknowledge(payload
          // Acknowledge only the processed logs
          .slice(0, json.payload.nb_processed).map(payloadElement => payloadElement.uid));
        } else if (json.payload.error_type === 'auth_error') {
          throw new Error('Wrong authentication token provided to REC');
        } else if (json.payload.error_type === 'input_error') {
          // When REC returns `input_error` we should not try to send them again
          acknowledge(payload.map(payloadElement => payloadElement.uid));
          throw new Error('Non-expected input conforming to REC directives');
        } else {
          // TODO Retry policy
          acknowledge([]);
        }
      } catch (error) {
        // TODO Retry policy
        acknowledge([]);
      }
    })();
  }
}
//# sourceMappingURL=index.js.map